module.exports = __webpack_public_path__ + "images/corners/Classic.e2b1ef71b6e56d575553ee9c774c42bd.jpg";